import { BoxProps, FlexProps } from '@gazin/ecommerce-ui'

type GetStylesProps = {
  container: BoxProps
  priceContent: FlexProps
  titleContent: FlexProps
}

export const getStyles = (
  scroll: boolean,
  stockAd?: number
): GetStylesProps => ({
  container: {
    boxShadow: [
      '0.25rem -0.3rem 0.938rem 0 #1415181A',
      '0.25rem 2.3rem 0.7rem 0 #14151833',
    ],
    className: `barra-fixa has-bottom-bar ${
      scroll && stockAd ? 'bottom-bar-visible' : ''
    }`,
    display: [stockAd ? 'flex' : 'none', 'initial'],
    opacity: scroll ? '1' : '0',
    pointerEvents: scroll ? 'all' : 'none',
    transform: [
      scroll ? 'translateY(0)' : 'translateY(3.125rem)',
      scroll ? 'translateY(0)' : 'translateY(-3.125rem)',
    ],
  },
  priceContent: {
    justifyContent: stockAd ? 'center' : 'flex-end',
  },
  titleContent: {
    width: stockAd ? '50%' : '75%',
  },
})
